<template>
	<modal
		name="bank-approved"
		:width="500"
		:height="'auto'"
		:adaptive="true"
		@before-open="beforeOpen"
		:clickToClose="false"
		:scrollable="true"
	>
		<div>
			<div
				class="content-modal-loading d-flex column align-center just-center"
				v-if="loading"
			>
				<div class="success-mesage">Проверка статуса оплаты</div>
				<div class="error-mesage-info">
					<div style="height: 90px; padding: 20px 0">
						<AppLoading :width="40" :height="40" color="#404370" />
					</div>
				</div>
			</div>
			<template v-else>
				<div class="content-modal-approve" v-if="checkState.successed">
					<div
						class="modal-approve"
						:class="[theme === 'dark-theme' && 'modal-approve_dark']"
					>
						<div class="modal-approve__text-container">
							<h3
								class="modal-approve__title"
								:class="theme === 'dark-theme' && 'modal-approve__title_dark'"
							>
								Вам доступен
								<span class="modal-approve__title_span">(1)</span> подарок
							</h3>
							<p
								class="modal-approve__subtitle"
								:class="
									theme === 'dark-theme' && 'modal-approve__subtitle_dark'
								"
							>
								Оплата прошла успешно!
							</p>
						</div>

						<img
							src="@/img/present.png"
							class="modal-approve__image"
							alt="Подарок"
						/>

						<div class="modal-approve__buttons-container">
							<a
								class="modal-approve__first-button"
								:class="
									theme === 'dark-theme' && 'modal-approve__first-button_dark'
								"
								href="https://квартплата.онлайн/gift?bid=11271"
								target="_blank"
							>
								Выбрать
							</a>
							<button
								class="modal-approve__second-button"
								@click="modalClose"
								:class="
									theme === 'dark-theme' && 'modal-approve__second-button_dark'
								"
							>
								Отказаться
							</button>
						</div>
					</div>

					<div v-if="!params.noSavecard" class="content-modal-approve__save">
						<div class="content-modal-approve__save-head">
							<div>
								Сохранить карту
							</div>
							<label
								class="content-modal-approve__save-toggle"
								:class="isCheked ? 'active' : ''"
							>
								<input v-model="isCheked" type="checkbox" />
								<div></div>
							</label>
						</div>
						<div class="content-modal-approve__save-description">
							Функция «Запомнить карту» - это возможность оплачивать квитанции
							одной кнопкой, без ввода номера карты, CVC и кода из СМС.
						</div>
						<button
							class="content-modal-approve__save-button"
							@click="modalButtonHandler"
						>
							{{ isCheked ? "Сохранить" : "Закрыть" }}
						</button>
					</div>
				</div>

				<div class="content-modal-approve__error" v-else>
					<div
						class="error-mesage"
						style="
							display: flex;
							width: 100%;
							justify-content: center;
							font-size: 55px;
						"
					>
						<i class="fas fa-exclamation-triangle"></i>
					</div>
					<div class="content-modal-approve__error-mesage">
						При оплате произошла ошибка
					</div>
					<div class="content-modal-approve__error-info">
						{{ checkState.Message }}
					</div>
					<div class="ontent-modal-approve__error-button">
						<AppBtn @click="modalClose" large block>
							Закрыть
						</AppBtn>
					</div>
				</div>
			</template>
		</div>
	</modal>
</template>

<script>
export default {
	data() {
		return {
			isCheked: false,
			message: "",
			params: {
				orderId: "",
				noSavecard: true
			},
			url: process.env.VUE_APP_URL,
			loading: true,
			checkState: {
				orderId: "",
				successed: true,
				Message: ""
			},
			theme: ""
		};
	},

	computed: {},
	methods: {
		modalButtonHandler() {
			if (this.isCheked) {
				this.saveCard();
				this.modalClose();
			} else {
				this.modalClose();
			}
		},
		modalClose() {
			this.$modal.hide("bank-approved");
		},

		async beforeOpen(event) {
			this.params.orderId = event.params.orderId;
			this.prepareCheckState(event.params.noSavecard);
			console.log("REFERRER", window.document.referrer);
			this.theme = this.$useTheme();
		},

		async saveCard() {
			await this.$store.dispatch("addCard", this.params.orderId);
		},

		async prepareCheckState(noSavecardParam) {
			this.loading = true;
			try {
				let query = await this.$store.dispatch(
					"prepareCheckState",
					this.params.orderId
				);

				if (query.successed) {
					this.canSaveCard(noSavecardParam);
				} else {
					this.params.noSavecard = true;
				}

				this.checkState = { ...query };
			} catch (e) {
				this.$errorsMod(e.response);
			}
			this.loading = false;
			history.pushState(null, null, "/account/");
			location.hash = "";
		},

		async canSaveCard(noSavecardParam) {
			let query = await this.$store.dispatch(
				"canSaveCard",
				this.params.orderId
			);

			if (query && !noSavecardParam) {
				this.params.noSavecard = false;
			} else {
				this.params.noSavecard = true;
			}
		}
	}
};
</script>

<style scoped>
.modal-approve {
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: #F1F2FF;
	padding: 48px 38px 38px 38px;
	box-shadow: 1px 1px 6px 0 #0000000f;
	border-radius: 24px;
}

.modal-approve_dark {
	background-color: #252525;
}

.modal-approve__text-container {
	display: flex;
	flex-direction: column;
	gap: 7px;
	text-align: center;
}

.modal-approve__title {
	font-size: 29px;
	font-weight: 600;
	line-height: 32px;
	color: #000000;
	margin: 0;
	padding: 0;
}

.modal-approve__title_span {
	color: #e6575d;
}

.modal-approve__title_dark {
	color: #fff;
}

.modal-approve__subtitle {
	font-size: 18px;
	font-weight: 400;
	line-height: 22px;
	color: #000000;
	margin: 0;
	padding: 0;
}

.modal-approve__subtitle_dark {
	color: #fff;
}

.modal-approve__image {
	width: 211px;
	height: 211px;
	margin: 20px 0 9px 0;
}

.modal-approve__buttons-container {
	display: flex;
	flex-direction: column;
	gap: 11px;
	width: 100%;
	max-width: 424px;
}

.modal-approve__first-button {
	font-family: "Montserrat", "Rubik";
	background-color: #0b2a61;
	display: flex;
	width: 100%;
	justify-content: center;
	align-items: center;
	margin: 0;
	font-size: 18px;
	font-weight: 500;
	line-height: 18px;
	color: #ffffff;
	border-radius: 14px;
	text-decoration: unset;
	cursor: pointer;
	height: 51px;
}

.modal-approve__first-button:hover {
	opacity: 0.7;
}

.modal-approve__first-button_dark {
	background: linear-gradient(90deg, #4062cf, #6521da);
}

.modal-approve__second-button {
	font-family: "Montserrat", "Rubik";
	display: flex;
	width: 100%;
	justify-content: center;
	align-items: center;
	color: #0B2A61;
	background-color: #FDFDFD;
	border-radius: 14px;
	font-size: 18px;
	font-weight: 500;
	line-height: 18px;
	cursor: pointer;
	margin: 0;
	box-sizing: border-box;
	height: 51px;
	border: unset;
}

.modal-approve__second-button:hover {
	background-color: #E5E6F4;
}

.modal-approve__second-button_dark {
	background-color: #343434;
}

.modal-approve__second-button_dark:hover {
	background-color: #4a4a4a;
}

@media screen and (max-width: 768px) {
	.modal-approve {
		padding: 24px 32px;
	}

	.modal-approve__title {
		font-size: 24px;
		line-height: 26px;
	}

	.modal-approve__subtitle {
		font-size: 15px;
		line-height: 18px;
	}

	.modal-approve__image {
		width: 142px;
		height: 142px;
		margin: 9px 0 0 0;
	}

	.modal-approve__buttons-container {
		max-width: 326px;
	}

	.modal-approve__first-button {
		height: 40px;
		font-size: 16px;
		line-height: 16px;
	}

	.modal-approve__second-button {
		height: 40px;
		font-size: 16px;
		line-height: 16px;
	}
}
</style>
